/**
 * セクショングループ管理者詳細ページ専用i18n定数
 */

export const SECTION_GROUP_ADMIN_DETAILS_I18N = {
  // ステータス
  status: {
    active: $localize`:@@sectionGroupAdmin.adminDetails.status.active:有効`,
    inactive: $localize`:@@sectionGroupAdmin.adminDetails.status.inactive:無効`,
  },

  // 性別オプション
  sex: {
    male: $localize`:@@sectionGroupAdmin.adminDetails.sex.male:男性`,
    female: $localize`:@@sectionGroupAdmin.adminDetails.sex.female:女性`,
    other: $localize`:@@sectionGroupAdmin.adminDetails.sex.other:その他`,
  },

  // ボタン
  button: {
    close: $localize`:@@sectionGroupAdmin.adminDetails.button.close:閉じる`,
  },

  // バリデーションメッセージ
  validation: {
    checkFields: $localize`:@@sectionGroupAdmin.adminDetails.validation.checkFields:各フィールドの内容を再度確認してください`,
    selectAtLeastOneRole: $localize`:@@sectionGroupAdmin.adminDetails.validation.selectAtLeastOneRole:権限を最低ひとつ選択してください。`,
    passwordMismatch: $localize`:@@sectionGroupAdmin.adminDetails.validation.passwordMismatch:２つのパスワードが一致しません。`,
  },

  // メッセージ
  message: {
    updateSuccess: $localize`:@@sectionGroupAdmin.adminDetails.message.updateSuccess:管理者の情報を更新しました。`,
    updateError: $localize`:@@sectionGroupAdmin.adminDetails.message.updateError:管理者の情報の更新に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
    inviteSuccess: $localize`:@@sectionGroupAdmin.adminDetails.message.inviteSuccess:管理者の招待メールを送信しました。`,
    inviteError: $localize`:@@sectionGroupAdmin.adminDetails.message.inviteError:管理者の招待に失敗しました。\n再度お試しください。\nこの問題が継続する場合はシステム管理者にご連絡ください。`,
    createSuccess: $localize`:@@sectionGroupAdmin.adminDetails.message.createSuccess:管理者を作成しました。`,
    createError: $localize`:@@sectionGroupAdmin.adminDetails.message.createError:管理者の作成に失敗しました。`,
  },
} as const;

export type SectionGroupAdminDetailsI18n = typeof SECTION_GROUP_ADMIN_DETAILS_I18N;
